var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessionallooking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 164,
    height: 164,
    rx: 82,
    fill: "#FDE2E1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_5335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.2502 82H102.75M62.2502 99.3571H102.75M114.322 61.75H50.6788C49.1443 61.75 47.6727 62.3595 46.5877 63.4446C45.5026 64.5296 44.8931 66.0012 44.8931 67.5357V113.821C44.8931 115.356 45.5026 116.827 46.5877 117.913C47.6727 118.998 49.1443 119.607 50.6788 119.607H114.322C115.856 119.607 117.328 118.998 118.413 117.913C119.498 116.827 120.107 115.356 120.107 113.821V67.5357C120.107 66.0012 119.498 64.5296 118.413 63.4446C117.328 62.3595 115.856 61.75 114.322 61.75ZM70.9288 44.3928H94.0716C95.6061 44.3928 97.0777 45.0024 98.1628 46.0874C99.2478 47.1725 99.8574 48.6441 99.8574 50.1785V61.75H65.1431V50.1785C65.1431 48.6441 65.7526 47.1725 66.8377 46.0874C67.9227 45.0024 69.3943 44.3928 70.9288 44.3928Z",
    stroke: "url(#paint0_linear_126_5335)",
    strokeWidth: 5.78571,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_5335",
    x1: 82.5002,
    y1: 44.3928,
    x2: 82.5002,
    y2: 119.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_5335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 81,
    fill: "white",
    transform: "translate(42 41.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionallooking);
export default __webpack_public_path__ + "static/media/professional looking.3445a3ff5928d71dfda0c8b10bc9af3a.svg";
export { ForwardRef as ReactComponent };